module.exports = __webpack_public_path__ + "static/media/osama.d1e0810f.png";